module.exports = __webpack_public_path__ + "static/media/assembly10.2963dc93.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/qci/sprites/gameRocketRepair/assembly10.png
// module id = 2428
// module chunks = 0